export function toCount(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

function normalizeChannels(raw) {
  const source = raw && typeof raw === "object" ? raw : {};
  return {
    facebook: toCount(source.facebook),
    instagram: toCount(source.instagram),
  };
}

/** Stored limit: missing is null. Zero is a real limit. */
export function storedLimit(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function normalizeConversationCounts(raw) {
  const source = raw && typeof raw === "object" ? raw : {};

  return {
    social: toCount(source.social),
    whatsapp: toCount(source.whatsapp),
    total: toCount(source.total),
    direct_messages: toCount(source.direct_messages),
    social_ad: toCount(source.social_ad),
    social_channels: normalizeChannels(source.social_channels),
    direct_messages_channels: normalizeChannels(source.direct_messages_channels),
    social_ad_channels: normalizeChannels(source.social_ad_channels),
    whatsapp_chat: toCount(source.whatsapp_chat),
    whatsapp_voice: toCount(source.whatsapp_voice),
    ads: (Array.isArray(source.ads) ? source.ads : []).map((row) => ({
      property_id: row?.property_id ?? "",
      title: row?.title || "Untitled property",
      ad_conversation_count: toCount(row?.ad_conversation_count),
    })),
    whatsapp_numbers: (Array.isArray(source.whatsapp_numbers)
      ? source.whatsapp_numbers
      : []
    ).map((row) => ({
      id: row?.id ?? row?.whatsapp_number ?? "",
      whatsapp_number: row?.whatsapp_number || "Unknown number",
      chat_count: toCount(row?.chat_count),
      voice_count: toCount(row?.voice_count),
    })),
  };
}

export function limitsFromSources({ whatsapp, properties } = {}) {
  const byPropertyId = {};
  (Array.isArray(properties) ? properties : []).forEach((property) => {
    const id = property?.id ?? property?.property_id;
    if (!id) return;
    const social = property?.meta?.social;
    byPropertyId[id] = social
      ? social.conversation_limit
      : property?.conversation_limit;
  });

  return {
    chat: whatsapp?.conversation_limit_chat,
    call: whatsapp?.conversation_limit_call,
    properties: byPropertyId,
  };
}
